import { C } from "../constants";

export const iStyle = {
  background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8,
  color: C.text, padding: "9px 12px", fontSize: 14, width: "100%", outline: "none",
};

export const lblSt = {
  color: C.muted, fontSize: 11, fontWeight: 600, letterSpacing: "0.06em",
  textTransform: "uppercase", marginBottom: 5, display: "block",
};

export const Badge = ({ children, color = "accent" }) => {
  const styles = {
    accent: { bg: "#5c5e60", col: "#f0eeeb" },
    blue:   { bg: "#3a5070", col: "#9dc4e8" },
    red:    { bg: "#6a3a3a", col: "#e8a0a0" },
    green:  { bg: "#3a5a40", col: "#90d0a0" },
    orange: { bg: "#5a4030", col: "#d8a878" },
  };
  const s = styles[color] || styles.accent;
  return (
    <span style={{
      display: "inline-block", padding: "2px 8px", borderRadius: 4,
      fontSize: 11, fontWeight: 600, letterSpacing: "0.04em", textTransform: "uppercase",
      background: s.bg, color: s.col,
    }}>{children}</span>
  );
};

export const Btn = ({ children, onClick, variant = "ghost", style: s = {} }) => {
  const variants = {
    primary: { background: C.accent,      color: "#1e1d1b", border: "none" },
    danger:  { background: "#6a3a3a",     color: "#e8a0a0", border: `1px solid #7a4a4a` },
    ghost:   { background: C.surface,     color: C.text,    border: `1px solid ${C.border}` },
    outline: { background: "transparent", color: C.accent,  border: `1px solid ${C.accent}` },
  };
  return (
    <button onClick={onClick} style={{
      padding: "9px 18px", borderRadius: 9, cursor: "pointer",
      fontWeight: 600, fontSize: 13, letterSpacing: "0.01em",
      ...variants[variant], ...s,
    }}>{children}</button>
  );
};

export const Field = ({ label, children, style: s = {} }) => (
  <div style={{ marginBottom: 12, ...s }}>
    <label style={lblSt}>{label}</label>
    {children}
  </div>
);

export const Modal = ({ children, onClose, title, wide = false }) => (
  <div
    style={{ position: "fixed", inset: 0, background: "rgba(20,20,22,0.7)", zIndex: 100, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 20px", overflowY: "auto" }}
    onClick={e => e.target === e.currentTarget && onClose()}
  >
    <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 16, padding: 26, width: "100%", maxWidth: wide ? 560 : 420 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
        <div style={{ fontWeight: 800, fontSize: 17, color: C.text }}>{title}</div>
        <button onClick={onClose} style={{ background: "none", border: "none", color: C.muted, fontSize: 22, cursor: "pointer", lineHeight: 1 }}>×</button>
      </div>
      {children}
    </div>
  </div>
);

export const StatCard = ({ label, value, sub, accent }) => (
  <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "18px 22px", flex: 1, minWidth: 110 }}>
    <div style={{ color: C.muted, fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>{label}</div>
    <div style={{ color: accent ? C.text : C.textDim, fontSize: 26, fontWeight: 700, lineHeight: 1 }}>{value}</div>
    {sub && <div style={{ color: C.textDim, fontSize: 12, marginTop: 5 }}>{sub}</div>}
  </div>
);
